import React, { useEffect, useRef, useState } from 'react'
import { SilentNode } from '../../types/nodeTypes'
import SkipButton from '../buttons/SkipButton'

type SilenceNodeProps = {
  node: SilentNode
  onSilenceEnded: () => void
}

const Silence: React.FC<SilenceNodeProps> = ({ node, onSilenceEnded }) => {
  const maxTime = node.seconds ?? 3
  const [elapsedTime, setElapsedTime] = useState(0)
  const startTimeRef = useRef<number | null>(null)
  const animationFrameRef = useRef<number | undefined>(undefined)

  useEffect(() => {
    const updateProgress = (timestamp: number): void => {
      startTimeRef.current ??= timestamp
      const deltaTime = (timestamp - startTimeRef.current) / 1000
      setElapsedTime(deltaTime)

      if (deltaTime < maxTime) {
        animationFrameRef.current = requestAnimationFrame(updateProgress)
      } else {
        setElapsedTime(maxTime)
        onSilenceEnded()
      }
    }

    animationFrameRef.current = requestAnimationFrame(updateProgress)

    return (): void => {
      if (animationFrameRef.current !== undefined) {
        cancelAnimationFrame(animationFrameRef.current)
      }
    }
  }, [onSilenceEnded, maxTime])

  return (
    <div className="silence-panel">
      <div className="silence-container">
        {node.message !== undefined && node.message.toLowerCase() !== 'fixme' && (
          <div className="node-message">{node.message}</div>
        )}
        <div className="message-background-text">
          <span className="silence-time">{Math.ceil(maxTime - elapsedTime)}</span>
          <div className="silent-progress-bar">
            <div
              className="silent-progress-bar-inner"
              style={{ width: `${(elapsedTime / maxTime) * 100}%` }}
            ></div>
          </div>
        </div>
      </div>
      <div>
        <SkipButton onClick={onSilenceEnded} />
      </div>
    </div>
  )
}

export default Silence
